export const boletoSituacoes = [
  {
    nome: "SALVO",
    label: "Em Processamento",
    cor: "#F7D23E",
  },
  {
    nome: "FALHA",
    label: "Falha",
    cor: "#A61E3C",
  },
  {
    nome: "EMITIDO",
    label: "Emitido",
    cor: "#0789B5",
  },
  {
    nome: "PENDENTE_RETENTATIVA",
    label: "Pendente Retentativa",
    cor: "#F28C28",
  },
  {
    nome: "REGISTRADO",
    label: "Registrado",
    cor: "#003366",
  },
  {
    nome: "REJEITADO",
    label: "Rejeitado",
    cor: "#E60000",
  },
  {
    nome: "BAIXADO",
    label: "Baixado",
    cor: "#79552F",
  },
  {
    nome: "LIQUIDADO",
    label: "Liquidado",
    cor: "#4FBB53",
  },
  {
    nome: "DESCARTADO",
    label: "Descartado",
    cor: "#565E64",
  },
];

export const statusValidosInclusao = [
  "DESCARTADO",
  "FALHA",
  "REJEITADO",
  "BAIXADO",
];

export const statusValidosConsulta = [
  "SALVO",
  "FALHA",
  "EMITIDO",
  "PENDENTE_RETENTATIVA",
  "REGISTRADO",
  "REJEITADO",
  "LIQUIDADO",
  "BAIXADO",
];

export const statusValidosRemessa = [
  "EMITIDO",
];

export const statusValidosBaixa = ["EMITIDO", "REGISTRADO"];

export const statusValidosDescarte = ["EMITIDO", "FALHA", "REJEITADO"];

export const statusInvalidosRenegociacao = ["DESCARTADO", "FALHA", "BAIXADO"];
